import gql from 'graphql-tag'

export const CREATE_UPDATE_CLIENT_CHARGES = gql`
mutation upsertClientCharges($clientCharges:[clientCharges_insert_input!]!, $updateColumns: [clientCharges_update_column!]!,
                             $chargesNA:[clientChargesNA_insert_input!]!, $updateColumnsChargesNA: [clientChargesNA_update_column!]!) {
  insert_clientCharges(objects: $clientCharges, on_conflict: {constraint: clientCharges_pkey, update_columns: $updateColumns}){
    affected_rows
  }
  insert_clientChargesNA(objects: $chargesNA, on_conflict: {constraint: clientChargesNA_pkey, update_columns: $updateColumnsChargesNA}){
    affected_rows
  }
}`
